// The colored-dot legend shared by the flow calendars (module types in the
// builder, active flows in the patient panel), so the two stay consistent.
export function CalendarLegend({
  items,
}: {
  items: { key: string; color: string; label: string }[];
}) {
  if (items.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-md">
      {items.map((it) => (
        <span
          key={it.key}
          className="flex items-center gap-xs text-xs text-textSecondary"
        >
          <span
            className="h-[8px] w-[8px] rounded-full"
            style={{ backgroundColor: it.color }}
          />
          {it.label}
        </span>
      ))}
    </div>
  );
}
